module.exports = __webpack_public_path__ + "img/DE05225.b476cf18.png";